import { c as _c } from "react/compiler-runtime";
import React from "react";
import { WaveWinnersDrop } from "./WaveWinnersDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { publicEnv } from "@/config/env";
import { getRenderableWaveDecisionWinners } from "@/helpers/waves/wave-decision.helpers";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
interface WaveWinnersDropsProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading?: boolean | undefined;
  readonly isApprovalWave?: boolean | undefined;
  readonly emptyMessage?: string | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveWinnersDrops: React.FC<WaveWinnersDropsProps> = t0 => {
  const $ = _c(30);
  const {
    wave,
    onDropClick,
    winners,
    isLoading: t1,
    isApprovalWave: t2,
    emptyMessage,
    contentPresentation: t3
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isApprovalWave = t2 === undefined ? false : t2;
  const contentPresentation = t3 === undefined ? "default" : t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== contentPresentation || $[1] !== emptyMessage || $[2] !== isApprovalWave || $[3] !== isLoading || $[4] !== onDropClick || $[5] !== wave || $[6] !== winners) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const renderableWinners = getRenderableWaveDecisionWinners(winners);
      const invalidWinnerCount = winners.length - renderableWinners.length;
      const shouldShowInvalidWinnerWarning = invalidWinnerCount > 0 && publicEnv.NODE_ENV !== "production";
      const invalidWinnersMessage = invalidWinnerCount === 1 ? "Hidden 1 winner with missing drop data." : `Hidden ${invalidWinnerCount} winners with missing drop data.`;
      if (isLoading) {
        let t8;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <div className="tw-h-0.5 tw-w-full tw-overflow-hidden tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-animate-loading-bar tw-bg-indigo-400" /></div>;
          $[11] = t8;
        } else {
          t8 = $[11];
        }
        t7 = t8;
        break bb0;
      }
      if (!renderableWinners.length) {
        if (shouldShowInvalidWinnerWarning) {
          let t8;
          if ($[12] !== invalidWinnersMessage) {
            t8 = <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p>;
            $[12] = invalidWinnersMessage;
            $[13] = t8;
          } else {
            t8 = $[13];
          }
          t7 = t8;
          break bb0;
        }
        if (emptyMessage) {
          let t8;
          if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = <CheckCircleIcon className="tw-size-10 tw-text-iron-600" />;
            $[14] = t8;
          } else {
            t8 = $[14];
          }
          let t9;
          if ($[15] !== emptyMessage) {
            t9 = <div className="tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-16"><div className="tw-flex tw-max-w-xs tw-flex-col tw-items-center tw-gap-4 tw-text-center">{t8}<p className="tw-mb-0 tw-text-base tw-font-medium tw-text-iron-300">{emptyMessage}</p></div></div>;
            $[15] = emptyMessage;
            $[16] = t9;
          } else {
            t9 = $[16];
          }
          t7 = t9;
          break bb0;
        }
        let t8;
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <></>;
          $[17] = t8;
        } else {
          t8 = $[17];
        }
        t7 = t8;
        break bb0;
      }
      t4 = "tw-space-y-3";
      if ($[18] !== invalidWinnersMessage || $[19] !== shouldShowInvalidWinnerWarning) {
        t5 = shouldShowInvalidWinnerWarning ? <p className="tw-rounded-md tw-border tw-border-amber-500/40 tw-bg-amber-500/10 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-200">{invalidWinnersMessage}</p> : null;
        $[18] = invalidWinnersMessage;
        $[19] = shouldShowInvalidWinnerWarning;
        $[20] = t5;
      } else {
        t5 = $[20];
      }
      let t8;
      if ($[21] !== contentPresentation || $[22] !== isApprovalWave || $[23] !== onDropClick || $[24] !== wave) {
        t8 = winner => <WaveWinnersDrop key={winner.drop.id} winner={winner} wave={wave} onDropClick={onDropClick} isApprovalWave={isApprovalWave} contentPresentation={contentPresentation} />;
        $[21] = contentPresentation;
        $[22] = isApprovalWave;
        $[23] = onDropClick;
        $[24] = wave;
        $[25] = t8;
      } else {
        t8 = $[25];
      }
      t6 = renderableWinners.map(t8);
    }
    $[0] = contentPresentation;
    $[1] = emptyMessage;
    $[2] = isApprovalWave;
    $[3] = isLoading;
    $[4] = onDropClick;
    $[5] = wave;
    $[6] = winners;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t8 = <div className={t4}>{t5}{t6}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
};